"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requireAsync;

var _immutable = require("immutable");

var _q = _interopRequireDefault(require("q"));

var _react = require("react");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _defer = _interopRequireDefault(require("q/js/lib/defer"));

var _require = (0, _memoize.default)(function (moduleName) {
  var deferredRequire = (0, _defer.default)();
  /* global hubspot */

  hubspot.require([moduleName], function (Module) {
    deferredRequire.resolve(Module);
  });

  return deferredRequire.promise;
});

function cancelAsyncRequire() {
  this.isAsyncRequireCancelled = true;
}

var addCancelFn = function addCancelFn(component) {
  if (component.cancelAsyncRequire) {
    return;
  }

  component.isAsyncRequireCancelled = false;
  component.cancelAsyncRequire = cancelAsyncRequire.bind(component);
};

function requireAsync(component, modules) {
  (0, _invariant.default)(component instanceof _react.Component, 'requireAsync: expected `component` to be an React class component instance but got `%s`', component);
  addCancelFn(component);
  var results = {};

  if (typeof modules === 'string') {
    modules = (0, _immutable.Seq)(modules);
  } else {
    (0, _invariant.default)(modules && modules.size > 0, 'requireAsync: a module name or iterable of names must be provided');
  }

  return _q.default.Promise.all(modules.map(function (name) {
    (0, _invariant.default)(typeof name === 'string', 'requireAsync: module name must be defined');
    return _require(name).then(function (Module) {
      if (!component.isAsyncRequireCancelled) {
        var parts = name.split(/[./]/);
        var moduleTitle = parts[parts.length - 1];
        results[moduleTitle] = Module;
      }
    });
  }).toArray()).then(function () {
    if (component.isAsyncRequireCancelled) {
      throw new Error('requireAsync: cancelled');
    }

    return results;
  });
}

module.exports = exports.default;